@use '@va/styles/variables.scss';
@use '@va/styles/mixins.scss';

.layout-content {
  width: 100%;

  &.sidebar-visible {
    @media screen and (min-width: 1024px) {
      margin-left: variables.$sidebarWidthCollapsed;
      width: calc(100% - #{variables.$sidebarWidthCollapsed});
    }
  }
}

#top-bar-icon-wrapper {
  svg {
    width: 24px;
  }
}

#top-bar {
  background-color: rgba(var(--color-secondary-rgb), 1);
}
